/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: Omit<PersonalRequisition, \'id\'>, schemaOptions: { title: \'NewPersonalRequisition\', exclude: [ \'id\' ] })
 */
export interface NewPersonalRequisition { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    employeeReplaceName?: string;
    employeeReplaceId?: number;
    salary?: number | null;
    city: string;
    creationReason?: string;
    code?: string;
    followsAuthorizationFlow?: boolean;
    requisitionTypeId?: string;
    jobPositionId?: string;
    currentStatusId?: string;
    immediateSuperiorId?: number;
    areaManagerId?: number;
    generalManagerId?: number;
    financeDirectorId?: number;
    createdByUser?: object;
    humanCapitalCompanyId?: string;
    companyId?: string;
    businessUnitId?: string;
}

